export const setTimerMixin = {
    data: function () {
        return {
            timer: {
                days: {
                    digit: '0',
                    title: this.$t('sales.timer.days'),
                },
                hours: {
                    digit: '00',
                    title: this.$t('sales.timer.hours'),
                },
                minutes: {
                    digit: '00',
                    title: this.$t('sales.timer.minutes'),
                },
                seconds: {
                    digit: '00',
                    title: this.$t('sales.timer.seconds'),
                },
            },
            countDown: null,
            interval: null,
            endsTonight: false,
        };
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    mounted() {
        this.setTimer();
    },
    methods: {
        setTimer: function () {
            let countDownTime;
            let localDateParts = this.timerEndtime.match(/(\d{4})-(\d{2})-(\d{2})/);
            if (localDateParts) {
                // Months starts at 0, November = 10, so we subtract 1 here.
                countDownTime = new Date(localDateParts[1], localDateParts[2] - 1, localDateParts[3]);
                countDownTime.setHours(24, 0, 0, 0);

                let timeNow = new Date();
                if (timeNow > countDownTime) {
                    countDownTime = new Date();
                    countDownTime.setHours(24, 0, 0, 0);
                }
            } else if (this.timerEndtime === 'local-midnight') {
                countDownTime = new Date();
                countDownTime.setHours(24, 0, 0, 0);
            } else {
                countDownTime = new Date(Number(this.timerEndtime));
            }

            this.countDown = countDownTime.getTime();

            // Init timer immediately on load
            this.timerInterval();

            // Set interval for timer
            this.interval = setInterval(this.timerInterval, 1000);
        },

        timerInterval: function () {
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;

            let now = new Date().getTime();
            let distance = this.countDown - now;

            //Property passed from the cookie affiliate campaign to force showing "Ends soon" title instead of "tonight".
            if (!this.topBarTimerForceEndsSoon) {
                if (Math.floor(distance / day) < 1) {
                    this.endsTonight = true;
                }
            }

            if (distance > 0) {
                this.setTimerOnTile(this.$t('sales.timer.days'), Math.floor(distance / day));
                this.setTimerOnTile(this.$t('sales.timer.hours'), Math.floor((distance % day) / hour));
                this.setTimerOnTile(this.$t('sales.timer.minutes'), Math.floor((distance % hour) / minute));
                this.setTimerOnTile(this.$t('sales.timer.seconds'), Math.floor((distance % minute) / second));
            }
        },
        setTimerOnTile: function (tile, digit) {
            switch (tile) {
                case this.$t('sales.timer.days'):
                    this.timer.days.digit = digit;
                    this.timer.days.title = digit === 1 ? this.$t('sales.timer.day') : this.$t('sales.timer.days');
                    break;
                case this.$t('sales.timer.hours'):
                    this.timer.hours.digit = digit < 10 ? '0' + digit : digit;
                    this.timer.hours.title = digit === 1 ? this.$t('sales.timer.hour') : this.$t('sales.timer.hours');
                    break;

                case this.$t('sales.timer.minutes'):
                    this.timer.minutes.digit = digit < 10 ? '0' + digit : digit;
                    this.timer.minutes.title =
                        digit === 1 ? this.$t('sales.timer.minute') : this.$t('sales.timer.minutes');
                    break;

                case this.$t('sales.timer.seconds'):
                    this.timer.seconds.digit = digit < 10 ? '0' + digit : digit;
                    this.timer.seconds.title =
                        digit === 1 ? this.$t('sales.timer.second') : this.$t('sales.timer.seconds');
                    break;

                default:
                    break;
            }
        },

        replacePlaceholderBasedOnTimer(title, futureText, tonightText) {
            let placeholder = '{placeholder}';

            if (!title.includes(placeholder)) {
                return title;
            }

            let now = new Date().getTime();
            let distance = this.countDown - now;
            let timer_diff_text = Math.floor(distance / (1000 * 60 * 60 * 24)) < 1 ? tonightText : futureText;

            return title.replace(placeholder, timer_diff_text);
        },
    },
};
